// Override Settings 
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: false,
        styleScrollToTop: 'style2',
        defaultDisplay: 'grid',
        showPlaceholderProductList: true,
        paginationType: 'load_more',
    },
  };
  
  var bcSfFilterTemplate = {
    'soldOutClass': 'product-price--sold-out grid-view-item--sold-out',
  
    // Grid Template
    'vendorGridHtml': '<div class="grid-view-item__vendor">{{itemVendorLabel}}</div>',
    'soldOutLabelGridHtml': ' <span class="product-price__sold-out">' + bcSfFilterConfig.label.sold_out + '</span>',

    'productGridItemHtml': '<div class="CollectionItemProduct col-sm-4 col-xs-4 product_item_on_collection col-md-3">' +
                                '<div class="grid-view-item product-card text-center" data-product-card="">' +
                                    '<div class="product product-card__image-with-placeholder-wrapper" data-image-with-placeholder-wrapper="" data-id="{{colorName}}">' +
                                        '<div class="grid-view-item__image-wrapper product-card__image-wrapper js">' +
                                            '{{itemWishlist}}' +
                                            '<ul class="grid--uniform product-single__thumbnails product_thum variant_product">' +
                                                '{{itemImages}}' +
                                            '</ul>' +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="grid_bottom_info_wrapper">' +
                                        '<div class="h4 grid-view-item__title product-card__title" aria-hidden="true">' +
                                            '<a href="{{itemUrl}}">' +
                                                '{{itemTitle}} {{variantTitle}}' +
                                            '</a>' +
                                        '</div>' +
                                        '{{itemSwatches}}' +
    									'{{itemPrice}}' +
                                    '</div>' +
    								'{{itemSizes}}' +
                                '</div>'+
                            '</div>',

    // Wishlist Template
    'wishlistHtml' :    '<a class="iWishAddColl iwishcheck" href="#" data-variant="{{variantId}}" data-product="{{itemId}}" data-ptitle="{{itemTitle}}">' +
                            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.39 18.96">' +
                                '<defs><style>.cls-1 {fill: #ed8721; }</style></defs>' +
                                '<title>Add to wishlist</title>' +
                                '<g id="Header"><path class="cls-1" d="M20.36,5.65C20.06,2.38,17.74,0,14.84,0a5.49,5.49,0,0,0-4.7,2.71A5.29,5.29,0,0,0,5.55,0C2.65,0,.33,2.38,0,5.65A5.85,5.85,0,0,0,.21,7.8,9.22,9.22,0,0,0,3,12.51L10.14,19l7.22-6.45A9.15,9.15,0,0,0,20.18,7.8a5.85,5.85,0,0,0,.18-2.15Zm-.94,2a8.46,8.46,0,0,1-2.58,4.31l-6.7,6-6.58-6A8.41,8.41,0,0,1,1,7.62,5,5,0,0,1,.81,5.78v0c.26-2.87,2.25-5,4.74-5a4.6,4.6,0,0,1,4.23,3l.36.86.36-.86A4.74,4.74,0,0,1,14.84.78c2.49,0,4.48,2.09,4.74,5a5,5,0,0,1-.16,1.85Zm0,0"></path></g>' +
                            '</svg>' +
                        '</a>',                        

    // Image Template
    'imageHtml' :   '<li>' +
                        '<a href="{{itemUrl}}">' +
                            '<img src="{{variantImage}}" alt="{{variantName}}" class="bc-sf-filter-product-item-main-image">' +
                        '</a>' +
                    '</li>',                    

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--tertiary btn--narrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Previous</span></a></li>',
    'previousDisabledHtml': '<li><div class="btn btn--tertiary btn--narrow btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Previous</span></div></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}" class="btn btn--tertiary btn--narrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Next</span></a></li>',
    'nextDisabledHtml': '<li><div class="btn btn--tertiary btn--narrow btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Next</span></div></li>',
    'paginateHtml': '<ul class="list--inline pagination clearfix">{{previous}}<li class="pagination__text">{{pageItems}}</li>{{next}}</ul>',
  
    // Sorting Template
    'sortingHtml': '<select id="bc-sf-sort-by" class="filters-toolbar__item text-right" style="width: 378px;">' +
                    '{{sortingItems}}' +
                    '</select>',
};

BCSfFilter.prototype.buildProductGridItem = function (data) {
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100;
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function (e) {
            return e.id == getParam('variant');
        });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/
    var _this = this;
    var itemHtml = '';
    var colorValues = [];
  	var isSplitProduct = false;
    var isFilterByColor = false;

    var filterByColor = []; 
  	var isFilterBySize = false;
    var filterBySize = []; 

  
    var filterByColor = []; 
    if (this.queryParams.pf_opt_color && this.queryParams.pf_opt_color.length > 0){
        isFilterByColor = true;
        filterByColor = this.queryParams.pf_opt_color;
    }
    /* Boost-223308 */
     if (this.queryParams.pf_opt_size && this.queryParams.pf_opt_size.length > 0){
        isFilterBySize = true;
        filterBySize = this.queryParams.pf_opt_size;
    }
  	var sizeFound = isFilterBySize ? false : true;
    data.variants.forEach(function(variant){
      if (variant.available){
        var isNewColor = false;
        var colorValue = '';
        variant.original_merged_options.forEach(function(merged_option){
            var optionName = merged_option.split(':')[0];
            var optionValue = merged_option.split(':')[1];
          var sizeValue = variant.hasOwnProperty("option_size") ? variant.option_size : ""
            if (optionName.includes('color') || optionName.includes('colour')  && variant.available){
                if (!colorValues.includes(optionValue) && (!isFilterByColor || filterByColor.includes(optionValue)) 
                    && ( !isFilterBySize || filterBySize.includes(variant.option_size))){
                    colorValues.push(optionValue);
                    isNewColor = true;
                    colorValue = optionValue;
                    sizeFound = true;
                }
            }
        });
        if (isNewColor && sizeFound){
          	isSplitProduct = true;
          	itemHtml += buildVariantProduct(data, variant, firstVariant, colorValue, isSplitProduct,_this);
        }
      }  
    });
  	if (!isSplitProduct){
      itemHtml = buildVariantProduct(data, firstVariant, firstVariant, '', isSplitProduct, _this)
  	}
  
  	if (data.product_type === 'Gift Card') {
      itemHtml = '';
    }
    return itemHtml;
}

function buildVariantProduct(data, variant, firstVariant, colorValue, isSplitProduct , _this){
    
    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add Images
    var itemImagesHtml = buildImage(data, variant, colorValue, isSplitProduct, _this);
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorGridHtml : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = buildPrice(data, variant, isSplitProduct);
  	// Hide not on sale variants on the sale collection
  	if (bcSfFilterMainConfig.general.collection_handle == "sale" && itemPriceHtml.indexOf('price--on-sale') == -1){
    	return '';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add swatch
    var itemSwatchesHtml = buildSwatch(data, _this);
    itemHtml = itemHtml.replace(/{{itemSwatches}}/g, itemSwatchesHtml);
  
  	// Add size
  	var itemSizes = buildSizes(data, variant, colorValue, isSplitProduct, _this);
  	itemHtml = itemHtml.replace(/{{itemSizes}}/g, itemSizes.html);
  	if (itemSizes.hasSizeOption && !itemSizes.html && isSplitProduct) return '';

    // Add wish list
    var itemWishlistHtml = bcSfFilterTemplate.wishlistHtml.replace(/{{variantId}}/g, variant.id);    
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

    // Add main attribute
  	var variantName =  colorValue.replace(/([a-z])([A-Z])/g, '$1 $2').trim();
  var variantTitle = '';	
  	if(variantName) {
  		variantTitle = '- <span>' + variantName + '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  	itemHtml = itemHtml.replace(/{{colorName}}/g, colorValue);  	
    itemHtml = itemHtml.replace(/{{variantTitle}}/g, variantTitle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, _this.buildProductItemUrl(data) + "?variant=" + variant.id);

    return itemHtml;
}

// Build image
function buildImage(data, variant, colorValue, isSplitProduct, _this){
    var itemImagesHtml = bcSfFilterTemplate.imageHtml;
    
    var productImagePath = bcSfFilterMainConfig.general.file_url.split('files/?')[0];
    	
  	var images = [];	
  
	if (isSplitProduct){
      if (data.metafields){
      	data.metafields.forEach(function(metafield){
        	var metafieldColor = metafield.value.replace(' ','').trim().toLowerCase();
          	var variantColor = colorValue.replace(' ','').trim().toLowerCase();
          	if (metafieldColor.includes(variantColor)){
              if (metafield.key.indexOf('cdn.shopify.com') == -1){
              	images.push(productImagePath + metafield.key);
              } else {
              	images.push(metafield.key);
              }              
        	}
    	})
      }

      if (images.length == 0 && variant.image){
        	images.push(variant.image);
      }
    }
  
  	if (!isSplitProduct || images.length == 0){
    	data.images_info.forEach(function(image){
				images.push(image.src);
		})      	
	} 
    
    if (images.length > 0){
        itemImagesHtml = itemImagesHtml.replace(/{{variantImage}}/g, images[0]);
        if (images.length > 1){
            itemImagesHtml += bcSfFilterTemplate.imageHtml;
            itemImagesHtml = itemImagesHtml.replace(/{{variantImage}}/g, images[1]);    
        } else {
            itemImagesHtml += bcSfFilterTemplate.imageHtml;
            itemImagesHtml = itemImagesHtml.replace(/{{variantImage}}/g, images[0]);
        }
    } else {
        itemImagesHtml += bcSfFilterTemplate.imageHtml;
        itemImagesHtml = itemImagesHtml.replace(/{{variantImage}}/g, bcSfFilterMainConfig.general.no_image_url);
    }
	var imageAlt = isSplitProduct ? (data.title + ' ' + colorValue) : data.title
  	itemImagesHtml = itemImagesHtml.replace(/{{variantName}}/g, imageAlt);
    return itemImagesHtml;
}

// Build Swatch
function buildSwatch(data, ob) {
    var _this = ob;
    var itemSwatchesHtml = '';
    var foundColorOption = false;
    data.options_with_values.forEach(function (option, index) {
        var optionName = option.name.toLowerCase();
        if (foundColorOption){ return; }
        if (optionName.indexOf('color') != -1 || optionName.indexOf('colour') != -1) {
            foundColorOption = true;
            var optionIndex = index;
            var values = [];
            itemSwatchesHtml += '<div class="collections_color">';
            data.variants.forEach(function (variant) {
                var temp = variant.merged_options[optionIndex].split(':');
                var value = temp[1];
                if (values.indexOf(value) == -1 && variant.available) {
                    values.push(value);
                    var slugifyValue = _this.slugify(value);                       
                    var colorBackground = slugifyValue.split('-').pop();
                    var colorBackgroundImage = _this.optimizeImage(bcSfFilterMainConfig.general.file_url.split('?')[0] + 'color-' + slugifyValue + '.png', '50x');
                  	var itemSwatchHtml ='<a href="{{variantUrl}}" data-id="{{colorName}}" class="color-swatch {{colorName}}__color" style="background-color:{{colorBackground}}; background-image:url({{colorBackgroundImage}})">' +
                                            '{{colorName}}' +
                                        '</a>';

                    itemSwatchHtml = itemSwatchHtml.replace(/{{colorName}}/g, value);
                    itemSwatchHtml = itemSwatchHtml.replace(/{{colorBackground}}/g, colorBackground);
                    itemSwatchHtml = itemSwatchHtml.replace(/{{colorBackgroundImage}}/g, colorBackgroundImage);
                  	itemSwatchHtml = itemSwatchHtml.replace(/{{variantUrl}}/g, _this.buildProductItemUrl(data) + "?variant=" + variant.id);
                    itemSwatchesHtml += itemSwatchHtml;
                }
            });
            itemSwatchesHtml += '</div>';
        }
    });
    return itemSwatchesHtml;
}

function buildPrice(data, variant, isSplitProduct) {
    var onSale = data.price_min < data.compare_at_price_min;
    var price = data.price_min; 
    var compare_at_price = data.compare_at_price_min;
    var available = data.available;
  	if (isSplitProduct){
  		onSale = variant.price < variant.compare_at_price;
        price = variant.price;
        compare_at_price = variant.compare_at_price;
    }
  
  	var priceHtml = '',
        onSaleClass = onSale ? ' price--on-sale' : '';
	  
    priceHtml += '<dl class="price' + onSaleClass + '" data-price>';
    if (bcSfFilterConfig.custom.vendor_enable) {
        priceHtml += '<div class="price__vendor">';
        priceHtml += '<dt>';
        priceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.vendor + '</span>';
        priceHtml += '</dt>';
        priceHtml += '<dd>';
        priceHtml += data.vendor;
        priceHtml += '</dd>';
        priceHtml += '</div>';
    }
    priceHtml += '<div class="price__regular">';
    priceHtml += '<dt>';
    priceHtml += '<span class="visually-hidden visually-hidden--inline">' + bcSfFilterConfig.label.regular_price + '</span>';
    priceHtml += '</dt>';
    priceHtml += '<dd>';
    priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
    if (available) {
        if (onSale) {
            priceHtml += bcsffilter.formatMoney(compare_at_price, bcsffilter.moneyFormat);
        } else {
            priceHtml += bcsffilter.formatMoney(price, bcsffilter.moneyFormat);
        }
    } else {
        priceHtml += bcSfFilterConfig.label.sold_out;
    }
    priceHtml += '</span>';
    priceHtml += '</dd>';
    priceHtml += '</div>';
    priceHtml += '<div class="price__sale">';
    priceHtml += '<dt>';
    priceHtml += '<span class="visually-hidden visually-hidden--inline">' + bcSfFilterConfig.label.sale_price + '</span>';
    priceHtml += '</dt>';
    priceHtml += '<dd>';
    priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
    priceHtml += bcsffilter.formatMoney(price, bcsffilter.moneyFormat);
    priceHtml += '</span> ';
    priceHtml += '<span class="price-item__label" aria-hidden="true">' + bcSfFilterConfig.label.sale + '</span>';
    priceHtml += '</dd>';
    priceHtml += '</div>';
    priceHtml += '</dl>';

    return priceHtml;
}

function buildSizes(data, currentVariant, colorValue, isSplitProduct, _this){
	var html = '';
  	var sizes = [];
  	var sizeItems = [];
  	var sizeItemsAvailable = 0;
  	var hasSizeOption = false;
  	data.variants.forEach(function(variant){
	  var isCurrentColor = false;
      if (!isSplitProduct) isCurrentColor = true;
      variant.original_merged_options.forEach(function(option){ 
        var key = option.split(":")[0].toLowerCase();
        var value = option.split(":")[1].toLowerCase();
        if ((key == 'color' || key == 'colour') && value == colorValue.toLowerCase()){
        	isCurrentColor = true;
        }               
      })
      var sizeValue = null;
      if (isCurrentColor){
          variant.original_merged_options.forEach(function(option){
          	var key = option.split(":")[0].toLowerCase();
        	var value = option.split(":")[1].toLowerCase();
        	if ((key == 'size' || key == 'sizes') && sizes.indexOf(value) == -1){
        		sizes.push(value);
              	sizeValue = value;
              	hasSizeOption = true;
        	}
          })
      }
      if (sizeValue){
      	var sizeUrl = _this.buildProductItemUrl(data) + "?variant=" + variant.id;
        var sizeItem = '';
        if (variant.available){
          sizeItem = '<li class="available"><a href="'+ sizeUrl +'">'+ sizeValue +'</a></li>';
          sizeItemsAvailable++;
        } else {
          sizeItem = '<li class="soldout">'+ sizeValue +'</li>';	
        } 
        sizeItems.push(sizeItem);
      } 
  	})
    if (sizeItemsAvailable > 0 && sizeItems.length > 0){
    	html = '<div class="bc-sf-size-list"><ul><li>+ SHOP</li>' + sizeItems.join("") + '</ul></div>';
    }
  	
  	return {
  	  html: html,
      hasSizeOption: hasSizeOption
  	};
}

BCSfFilter.prototype.buildProductListItem = function (data) {
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function (e) {
            return e.id == getParam('variant');
        });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productListItemHtml;

    // Add onSale label
    var itemSaleLabel = onSale ? bcSfFilterTemplate.saleLabelListHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

    // Add soldOut label
    var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelListHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '600x600') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Vendor
    var itemSmallVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorSmallListHtml : '';
    itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
    var itemMediumVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorMediumListHtml : '';
    itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

    // Add Price
    var itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Build page items
        var currentPage = bcSfFilterConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
  	matchHeightImage();
  	jQ(window).resize(function() {
    	matchHeightImage();
  	});
  
  //	initWishlist();
};

function matchHeightImage() {
  var maxHeight = 0;
  var total = jQ('.bc-sf-filter-product-item-main-image').length;
  var count = 0;
  jQ('.bc-sf-filter-product-item-main-image').load(function() {
    var imageContainer = jQ(this).closest('.variant_product');
    var height = jQ(this).height();
    if (height > maxHeight) maxHeight = height;    
    imageContainer.css('width', '100%').css('height', jQ(this).height());
    //imageContainer.find('li').css('width', '100%').css('height', jQ(this).height());
    
    count++;
    if (count == total){
    	jQ('.variant_product').css('height', maxHeight);
      	jQ('.variant_product li').css('height', maxHeight);
      	if (bcsffilter.isMobile()) jQ('.bc-sf-size-list').css('max-height', maxHeight - 10);
      	else jQ('.bc-sf-size-list').css('max-height', 'none');
      	count = 0;
    }
  }).each(function() {
    if (this.complete) jQ(this).load();
  });
}

/*function initWishlist(){
    jQ(".iWishAddColl.iwishcheck").on('click', function (e) {
            e.preventDefault();
            var iWishvId = jQ(this).attr("data-variant");
            iwish_addCollection(jQ(this), iWishvId);
            return false;
    });
    iwishCheckColl();
} */

// Fix weird bug where collection all has wrong id from liquid
bcSfFilterMainConfig.general.collection_id = bcSfFilterConfig.custom.collection_id;
bcSfFilterMainConfig.general.collection_handle = bcSfFilterConfig.custom.collection_handle;

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

BCSfFilter.prototype.prepareProductData = function(data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; if(data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0){ data[k].tags = data[k]['original_tags'].slice(0); }} return data };


// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
